import { AccessPointProcessingStep, ImportStepDetailResponse } from "../models";

export interface ImportSidePanelState {
  step?: AccessPointProcessingStep;
  tab?: ImportSidePanelTab;
  stepDetail?: ImportStepDetailResponse;
  isOpen: boolean;
  isLoading: boolean;
  error?: string;
}

export enum ImportSidePanelTab {
  Results = "Results",
  Settings = "Settings",
}
